import _isNil from "lodash/isNil";
export var convertCssTimeToNumber = function convertCssTimeToNumber(time) {
  if (_isNil(time) || time === 'initial' || time === 'inherit') {
    return 0;
  }
  var lastTwoCharacters = time.slice(-2);
  if (lastTwoCharacters !== 'ms' && lastTwoCharacters[1] !== 's') {
    return 0;
  }
  var isMs = lastTwoCharacters === 'ms';
  var multiplier = isMs ? 1 : 1000;
  var stringNumber = isMs ? time.slice(0, -2) : time.slice(0, -1);
  var number = parseFloat(stringNumber);
  return isNaN(number) ? 0 : multiplier * number;
};
//# sourceMappingURL=convertCssTimeToNumber.js.map
